import React from 'react';
import ShipFromComponent from '../../../../../fulfillment-planner/ship-from';
import classNames from 'clsx';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import ShipFromLabel from '../../../../../fulfillment-planner/ship-from/label';
import ShipFromValidator from '../../../../../fulfillment-planner/ship-from/validator';
import RateBrowserButton from '../../../../../fulfillment-planner/rate-browser-button';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @param {boolean} props.hideFulfillmentProviders
 * @param {boolean} props.hideRateBrowserButton
 * @returns {JSX.Element}
 */
export const ShipFrom = ({ fulfillmentPlanId, hideFulfillmentProviders = false, hideRateBrowserButton = false }) => (
  <ShipFromValidator fulfillmentPlanId={fulfillmentPlanId} showFulfillmentProviders={!hideFulfillmentProviders}>
    {({ validation }) => (
      <>
        <div
          className={classNames(
            style.label,
            { [style['lable-with-helper-text']]: validation.helperText },
            {
              [style.error]: validation.helperTextType === INLINE_MESSAGE_TYPES.error,
            },
          )}
        >
          <ShipFromLabel />
        </div>
        <ShipFromComponent showFulfillmentProviders={!hideFulfillmentProviders} validation={validation} />
        <div>{!hideRateBrowserButton && <RateBrowserButton />}</div>
      </>
    )}
  </ShipFromValidator>
);
